import localCache from './localCache';
import { STORAGE_KEYS } from './storageKeys';

const setImportNotification = (importerId, integrationId) => {
  localCache.set(STORAGE_KEYS.IMPORT_LOCATION_ID, importerId);
  localCache.set(STORAGE_KEYS.IMPORT_LOCATION_INTEGRATION_ID, integrationId);
  localCache.set(STORAGE_KEYS.SHOULD_DISPLAY_NOTIFICATION, true);
};

export default setImportNotification;
